// src/components/HeroSection.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiArrowRight, FiPlay } from "react-icons/fi";
import "./HeroSection.css";

const phrases = [
  "Empowering Agriculture with AI",
  "Hands-on Internship & Mentorship",
  "Build Real-World GenAI Projects",
];

export default function HeroSection() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % phrases.length);
    }, 2600);
    return () => clearInterval(id);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // use PUBLIC_URL so it works in dev & build with assets in /public/images
  const bg = `${process.env.PUBLIC_URL}/images/aibackground.jpg`;

  return (
    <header className="hero" style={{ backgroundImage: `url(${bg})` }}>
      <div className="hero-overlay" />
      <motion.div
        className="hero-inner"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <p className="eyebrow">MSME-led • Free • Industry Mentors</p>

        <motion.h1
          key={index}
          className="headline"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {phrases[index]}
        </motion.h1>

        <p className="sub">
          Learn GenAI, Computer Vision & Smart Agriculture by building projects
          that matter to farmers — from crop analytics to irrigation intelligence.
        </p>

        <div className="cta-row">
          <button className="cta cta-primary" onClick={() => go("register")}>
            Join the Program <FiArrowRight />
          </button>
          <button className="cta cta-secondary" onClick={() => go("about")}>
            Explore Program <FiPlay />
          </button>
        </div>
      </motion.div>
    </header>
  );
}
